import { RollbackBadge } from './style';
import ArrowBackIcon from '../../assets/icons/arrow-back.svg?react';

interface RollbackProps {
  title: string;
}

const Rollback = ({ title, ...props }: RollbackProps) => {
  return (
    <RollbackBadge {...props}>
      <span>
        <ArrowBackIcon />
      </span>
      <p>{title}</p>
    </RollbackBadge>
  );
};

export default Rollback;
